import { gql } from "@apollo/client";

export const CHECK_SITE_INSTALLED = gql`
  query CheckSiteInstalled($sitePublicIds: [ID!]!) {
    siteInstalled(sitePublicIds: $sitePublicIds) {
      siteId
      isInstalled
      installedAt
    }
  }
`;

export const CHECK_CAMPAIGNS_INSTALLED = gql`
  query CheckCampaignsInstalled(
    $sitePublicId: ID!
    $campaignPublicIds: [ID!]!
  ) {
    campaignInstalled(
      sitePublicId: $sitePublicId
      campaignPublicIds: $campaignPublicIds
    ) {
      campaignId
      isInstalled
    }
  }
`;
